import { render, staticRenderFns } from "./CheckBehaviorEditor.vue?vue&type=template&id=1610a31f&scoped=true&"
import script from "./CheckBehaviorEditor.vue?vue&type=script&lang=ts&"
export * from "./CheckBehaviorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBehaviorEditor.vue?vue&type=style&index=0&id=1610a31f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1610a31f",
  null
  
)

export default component.exports